import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from './types/User';
import { APIV2_URL } from './constants';

const getUser =
  (makeCall: MakeCall) =>
  (userId: number | 'me' = 'me') =>
    makeCall<User>('GET', `${APIV2_URL}/user/${userId}`);

export default getUser;
